import React from "react";
import { JobArrangerProps } from "../JobArrangerProps";
import { JobArrangerLayout } from '../JobArrangerLayout';
import { JobArrangerEntities } from "../JobArrangerEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";

interface ReasonListPageProps extends NSARouterMakerResult, JobArrangerProps { }

export default class ReasonListPage extends React.Component<ReasonListPageProps>
{
	override render()
	{
		return (
			<JobArrangerLayout
				{...this.props}
				action={{
					title: "",
					description: "Reasons for adding a job to your list, such as matching skills or salary, that are default or added by you. Reasons are assigned to statuses.",
					menus: {}
				}}
				pages={{
					entity: JobArrangerEntities.reason(this.props),
					list: {
						ui: {}
					}
				}}
			>
				<></>

			</JobArrangerLayout >
		);
	}
}